import {
    headers,
    getGraphViewTrackerListUrl,
    GET_GRAPH_VIEW_AUDIT_TRACKER_LIST
} from "../../../utils/constants"
import { axiosPost, axiosGet } from "../../../react_axios/Axios"
import moment from 'moment';

export const getGraphViewAuditTrackerList_action = (HallID,VendorID, ServiceID) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            HallID: HallID != '' ? HallID : null,
            VendorID: VendorID != '' ? VendorID : null,
            ServiceID: ServiceID != '' ? ServiceID : null,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }

        const res = await axiosGet(getGraphViewTrackerListUrl, params, headers);
        dispatch({
            type: GET_GRAPH_VIEW_AUDIT_TRACKER_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}